import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./redux/store";
import { RouterProvider } from "react-router-dom";
import { Authenticated, unAuthenticated, notAllow } from "./App";
import "react-toastify/dist/ReactToastify.css";

import { ToastContainer } from "react-toastify";

const root = ReactDOM.createRoot(document.getElementById("root"));

const token = localStorage.getItem("scrap_market_admin");
const isAdmin = localStorage.getItem("isAdmin");

root.render(
  <Provider store={store}>
    <ToastContainer />
    <RouterProvider
      router={
        token && isAdmin
          ? Authenticated
          : token && !isAdmin
          ? notAllow
          : unAuthenticated
      }
    />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
